// Fixed visual language for the sysblu system editor.
//
// Unlike the model editor style, sysblu currently has one color scheme. Keep
// every authored drawing choice here so widgets and routes share one coherent
// visual language and a future theme does not require hunting through renderers.
export const systemStyle = {
    canvas: {
        background: '#000000',
        emptyText: '#667085',
        emptyFont: '14px system-ui, sans-serif',
        emptyTextAlign: 'center',
        emptyTextBaseline: 'middle',
        outline: 'none',
        touchAction: 'none',
        cursorDefault: 'default',
        cursorMove: 'move',
        cursorGrab: 'grab',
        cursorGrabbing: 'grabbing',
        cursorReference: 'pointer',
    },
    application: {
        width: 290,
        headerHeight: 36,
        referenceRowHeight: 34,
        endpointRowHeight: 34,
        bottomPadding: 8,
        cornerRadius: 8,
        fill: '#8e8e8e',
        externalFill: '#8e8e8e',
        nodeColor: 'hsl(218, 70%, 34%)',
        externalNodeColor: 'hsl(0, 0%, 20%)',
        borderWidth: 2,
        selected: '#ff7700',
        selectedBorderWidth: 4,
        titleText: '#ffffff',
        titleFont: '600 14px system-ui, sans-serif',
        titleTextAlign: 'center',
        titleTextBaseline: 'middle',
        settingsSize: 24,
        settingsLeftPadding: 6,
        settingsGlyph: '\u2699',
        settingsText: '#ffffff',
        settingsFont: '17px system-ui, sans-serif',
        settingsTextAlign: 'center',
        settingsTextBaseline: 'middle',
        settingsTextOffsetY: 0.5,
        settingsTooltip: 'Edit application',
        addEndpointSize: 24,
        addEndpointRightPadding: 6,
        addEndpointGlyph: '+',
        addEndpointText: '#ffffff',
        addEndpointFont: '600 20px system-ui, sans-serif',
        addEndpointTextAlign: 'center',
        addEndpointTextBaseline: 'middle',
        addEndpointTextOffsetY: -0.5,
        addEndpointTooltip: 'Add endpoint',
        dividerWidth: 1.5
    },
    reference: {
        size: 24,
        gap: 6,
        leftPadding: 10,
        cornerRadius: 4,
        fill: '#76c8e6',
        border: '#000000',
        borderWidth: 1,
        text: '#000000',
        font: '600 9px system-ui, sans-serif',
        textAlign: 'center',
        textBaseline: 'middle',
        textOffsetY: 0,
        commandMarker: '#0037ff',
        commandMarkerRadius: 2,
        commandMarkerBottomPadding: 3,
    },
    endpoint: {
        radius: 6,
        hitRadius: 8,
        border: '#000000',
        borderWidth: 1,
        text: '#07090d',
        textFont: '12px system-ui, sans-serif',
        detailText: '#2d313b',
        detailFont: '10px system-ui, sans-serif',
        horizontalPadding: 12,
        nameOffsetY: 10,
        detailOffsetY: 23,
        textBaseline: 'middle',
        leftTextAlign: 'left',
        rightTextAlign: 'right',
        server: '#00ff80',
        client: '#ff8000',
        peer: '#8000ff',
        connectionTooltip: 'Drag to another endpoint to create a connection',
        settingsTooltip: 'Edit endpoint',
    },
    route: {
        normal: '#00ccff',
        selected: '#ff7700',
        broken: '#ff0019',
        width: 4,
        selectedWidth: 4,
        brokenDash: [6, 4],
        hitTolerance: 7,
        endpointStub: 24,
        bypassGap: 30,
        arrowLength: 15,
        arrowAngle: Math.PI / 6,
        labelBackground: '#1d2045',
        labelBorder: '#00ccff',
        labelBorderWidth: 1.5,
        labelCornerRadius: 6,
        labelFont: '12px system-ui, sans-serif',
        labelPaddingX: 8,
        labelHeight: 24,
        labelTextAlign: 'center',
        labelTextBaseline: 'middle',
        draft: '#ff7700',
        draftWidth: 2,
        draftDash: [6, 4],
    },
    text: {
        measureCharacterWidth: 7,
    },
}
